import { connect } from 'react-redux';
import { loadHotel, sendHotelFeedback, hotelUnsubscribe } from '../modules/feedback';

import HotelFeedback from '../components/HotelFeedback';


const mapDispatchToProps = {
  sendHotelFeedback,
  loadHotel,
  hotelUnsubscribe,
};

const mapStateToProps = (state, ownProps) => ({
  isFetching: state.feedback.isFetching,
  needFetch: state.feedback.needFetch,
  hotel: state.feedback.hotel,
  hotelId: ownProps.params.id,
  action: ownProps.params.action ? ownProps.params.action : 'default',
});

export default connect(mapStateToProps, mapDispatchToProps)(HotelFeedback);



// WEBPACK FOOTER //
// src/routes/feedback/containers/HotelFeedbackContainer.js